import { AppPermissions } from 'constants/permissions';

export const permissions = {
  addShippingZone: [AppPermissions.add_shippingzones],
  editShippingZone: [AppPermissions.change_shippingzones],
  deleteShippingZone: [AppPermissions.delete_shippingzones],
};
